export function filesSortBy({ documents }) {
  return documents.sortBy;
}

export function filesList({ documents }) {
  return documents.filesList;
}
